import fr from 'facet-rest';

const WorkspacesOverride = fr.metaOverride().nameOverride('tabs', {
  _hideLabel: true,
});

export default WorkspacesOverride;
